import { DateTime } from "luxon";

export const formatDateTime = (date: string) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT);

export const DATE_MEDIUM = {
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
} as const;

export const withinNDays = (n: number) => DateTime.now().plus({ days: n }).toISO();

export const isToday = (date: string) => DateTime.fromISO(date).hasSame(DateTime.local(), "day");

export const formatDate = (date: string, format: string) => DateTime.fromISO(date).toFormat(format);
